<template>
  <div>
    <div
      style="text-align: center; padding-left: 30% !important ; position: absolute"
      width="100%"
    >
      <v-alert
        v-if="responseStatus.alertStatus"
        :type="responseStatus.type"
        width="100%"
        style="z-index: 9999; text-align: left"
        dense
        dismissible
        @input="dialog = !dialog"
      >
        {{ responseStatus.text }}
      </v-alert>
    </div>
    <v-card>
      <v-card-text
        ><qrcode-stream @detect="onDetected"></qrcode-stream>

        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <v-btn class="success" @click="onSearch">ค้นหาจากรหัส</v-btn>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="dialog"
      max-width="100%"
      hide-overlay
      style="z-index: 99999"
      min-height="20em"
    >
      <redeem-info
        v-if="redeemInfo !== undefined"
        v-bind:redeemInfo="redeemInfo"
        @updateRedeem="updateRedeem($event)"
        @close="close($event)"
      ></redeem-info>
      <v-alert
        v-else
        type="error"
        width="100%"
        style="z-index: 9999; text-align: left"
        dense
        dismissible
        @input="dialog = !dialog"
      >
        ไม่พบรหัสแลกของรางวัล
      </v-alert>
    </v-dialog>
  </div>
</template>
<script>
import redeemInfo from "./redeem-pending.vue";
import axios from "axios";
// eslint-disable-next-line no-unused-vars
import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from "vue-qrcode-reader";
export default {
  name: "Redeem",
  components: {
    QrcodeStream,
    "redeem-info": redeemInfo,
    //QrcodeDropZone,
    //QrcodeCapture,
  },
  data() {
    return {
      dialog: false,
      qrDecoded: "",
      redeemInfo: "",
      api_uri: process.env.VUE_APP_LOYALTY_API_URI,
      closeInSec: process.env.VUE_APP_ALERT_DISPLAY * 1000,
      responseStatus: {
        alertStatus: false,
        text: "",
      },
    };
  },
  methods: {
    async updateRedeem(data) {
      console.log(data);
      let payload = {
        ...data,
        MemberTierPrivilegeId: this.redeemInfo._id,
        custId: sessionStorage.getItem("custId"),
      };
      //let response = await this.$store.dispatch("updatePendingRedeem", payload);
      try {
        await axios
          .put(
            this.api_uri + "/v1/redeem-tier-privileges/update",
            payload, // need to change
            {
              headers: {
                // Overwrite Axios's automatically set Content-Type
                "Content-Type": "application/json",
                "token": sessionStorage.getItem("token"),
              },
            }
          )
          .then((response) => {
            console.log(response);
            if (response.data.code == 0) {
              this.responseStatus = {
                status: "Success",
                code: 0,
                color: "green",
                type: "success",
                text: "บันทึกสำเร็จ",
                alertStatus: true,
              };
            } else {
              this.responseStatus = {
                status: "Error",
                code: 500,
                color: "red",
                type: "error",
                text: "ไม่สำเร็จ",
                alertStatus: true,
              };
            }
          });
      } catch (err) {
        //console.log(err)
        //return err;
        this.responseStatus = {
          status: "Error",
          code: 500,
          color: "red",
          type: "error",
          text: err,
          alertStatus: true,
        };
      }
      this.dialog = !this.dialog;
      //console.log("updateRedeem (QR)");
      //console.log(this.dialog);
      //console.log(response);
    },
    async ondecode(decodedString) {
      console.log("onDecoded");
      this.qrDecoded = decodedString;
      console.log(this.qrDecoded);
      //alert(this.qrDecoded);
    },
    async onSearch() {
      let redeem = await axios.get(
        this.api_uri + "/v1/redeem-tier-privileges/code/" + this.search,
        {
          params: {
            updateBy: sessionStorage.getItem("email"),
            custId: sessionStorage.getItem("custId"),
            apiKey: sessionStorage.getItem("apiKey"),
          },
        }
      );
      console.log(redeem);
      this.redeemInfo = redeem.data.data;
      this.$store.state.redeem.pending = this.redeemInfo;
      //this.$router.push({ name: "RedeemPending" });
      this.dialog = true;
    },
    async onDetected(promise) {
      console.log("onDetected");
      try {
        const {
          content, // decoded String
          location, // QR code coordinates
        } = await promise;
        //console.log(content);
        //alert(content);
        console.log(location);
        let redeem = await axios.get(
          this.api_uri + "/v1/redeem-tier-privileges/code/" + content,
          {
            params: {
              updateBy: sessionStorage.getItem("email"),
              custId: sessionStorage.getItem("custId"),
              apiKey: sessionStorage.getItem("apiKey"),
            },
          }
        );
        console.log(redeem);
        this.redeemInfo = redeem.data.data;
        this.$store.state.redeem.pending = this.redeemInfo;
        //this.$router.push({ name: "RedeemPending" });
        this.dialog = true;
        // ...
      } catch (error) {
        // ...
        console.log(error);
      }
    },
    close() {
      this.dialog = !this.dialog;
    },
    closeInTime(sec) {
      setTimeout(() => {
        this.responseStatus.alertStatus = false;
      }, sec);
    },
  },
  watch: {
    dialog: {
      handler(val) {
        console.log("dialog");
        if (!val) {
          this.responseStatus.alertStatus = false;
        }
      },
    },
    responseStatus: {
      handler() {
        if (this.responseStatus.alertStatus === true) {
          this.closeInTime(this.closeInSec);
        }
      },
    },
  },
};
</script>
<style scoped></style>
